import { AbstractControl } from '@angular/forms';
import { GenericAccountValidator } from './generic-account-validator';

export class EthereumAddressAccountValidator extends GenericAccountValidator {
    protected static errors: any = {
        'es-AR': {
            bad_email: 'Dirección incorrecta, debe ser por ejemplo: 0x864B5E3C7d6260CE1c89AC6f9F63779FB36c3942'
        },
        'en-US': {
            bad_email: 'Incorrect adress, here`s an example: 0x864B5E3C7d6260CE1c89AC6f9F63779FB36c3942'
        }
    };
    protected static label: any = {
        'es-AR': 'Dirección ERC20',
        'en-US': 'ERC20 Adress'
    };
    protected static placeholder: any = {
        'es-AR': 'Por ejemplo: 0x864B5E3C7d6260CE1c89AC6f9F63779FB36c3942',
        'en-US': 'For example: 0x864B5E3C7d6260CE1c89AC6f9F63779FB36c3942'
    };
    public getLabelToAccountType(): string {
        return (
            EthereumAddressAccountValidator.label[EthereumAddressAccountValidator.lang] ?? EthereumAddressAccountValidator.label['es-AR']
        );
    }

    public getPlaceholderToAccountType(): string {
        return (
            EthereumAddressAccountValidator.placeholder[EthereumAddressAccountValidator.lang] ??
            EthereumAddressAccountValidator.placeholder['es-AR']
        );
    }

    public accountValidate(control: AbstractControl): { [key: string]: any } | null {
        let error: any =
            EthereumAddressAccountValidator.errors[EthereumAddressAccountValidator.lang] ?? EthereumAddressAccountValidator.errors['es-AR'];
        if (/^0x[a-fA-F0-9]{40}$/.test(control.value)) {
            return null;
        }

        return { forbiddenName: error.bad_email };
    }
}
